import { render, staticRenderFns } from "./ModalAddStore.vue?vue&type=template&id=1af11bb9&lang=pug"
import script from "./ModalAddStore.vue?vue&type=script&lang=js"
export * from "./ModalAddStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports